import { Col, Row } from 'react-bootstrap';
import ColumnsChart from '../../../../components/ApexCharts/ColumnsChart';
import ColumnsCustomLegend from '../../../../components/ApexCharts/CustomLegends/ColumnsCustomLegend';
import Blockquote from '../../../../components/Blockquote';
import { formatPrice } from '../../../../utils/utils';

const otherBenefitsData = {
  chart: {
    stacked: true,
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
  },
  colors: ['#C4D2D9'],
  series: [
    {
      name: 'CorePlus Legal Benefit',
      data: [250],
    },
  ],

  dataLabels: {
    enabled: false,
  },
  fill: {
    opacity: 1,
  },
  legend: {
    show: false,
  },
  plotOptions: {
    bar: {
      horizontal: false,
    },
  },

  // Appply this states configuration to disable hover state.
  // It would be strange to have only one column on the chart, that flickers on hover.
  states: {
    hover: {
      filter: {
        type: 'none',
      },
    },
  },
  tooltip: {
    enabled: false,
  },
  xaxis: {
    categories: [0, 1],
    overwriteCategories: ['You Contribute'],
    tickAmount: 1,

    labels: {
      rotate: 0,
    },
  },
  yaxis: {
    title: {
      text: '',
    },
    labels: {
      formatter: function (a: any) {
        return formatPrice(a, 'en-US', {
          currency: 'USD',
          style: 'currency',
          minimumFractionDigits: 0,
        });
      },
    },
  },
};

const OtherBenefitsTab = () => {
  return (
    <div className="pt-11">
      <Row>
        <h5>Other Benefits</h5>
      </Row>
      <Row>
        <span className="text-light-grey text-fs-6 fw-light lh-xs">
          Some other benefits, such as EAP, may be offered through the company
          but not represented below.
        </span>
      </Row>
      <Row className="pt-11 lh-xs px-4">
        <Blockquote>
          <section>
            <Row>
              <Col className="title-span fw-bolder">
                Let's help you understand this information
              </Col>
            </Row>
            <Row>
              <Col>
                Cash Compensation is shown by calendar year. Your current year
                amount represents what you have received year-to-date plus a
                projection based on your current pay rate.
              </Col>
            </Row>
          </section>
        </Blockquote>
      </Row>
      <Row className="pt-12 px-lg-0 px-7">
        <Col className="col-lg-5 col-12">
          <ColumnsChart
            series={otherBenefitsData.series}
            options={otherBenefitsData}
          />
        </Col>
        <Col className="lh-xs col-lg-6 col-12 ps-lg-12 ms-lg-12">
          <Row className="text-fs-6 fw-normal pt-3 lh-xs border-bottom">
            <Col className="col-6"></Col>
            <Col className="col-3 text-end">We contribute</Col>
            <Col className="col-3 text-end">You contribute</Col>
          </Row>
          <ColumnsCustomLegend
            series={[
              {
                name: 'CorePlus Legal Benefit',
                data: [0, 250],
              },
            ]}
            colors={otherBenefitsData.colors}
            total={['$0', '$250']}
          />
        </Col>
      </Row>
      <Row className="pt-11 mt-11 lh-xs">
        <h5>Suggestions</h5>
      </Row>
      <Row className="pt-7 lh-xs px-lg-0 px-7">
        <Blockquote>
          <section>
            <Row>
              <Col className="title-span fw-bolder">Legal Benefits</Col>
            </Row>
            <Row>
              <Col>
                Remember to use your legal benefits; have you updated that will
                yet?
              </Col>
            </Row>
          </section>
        </Blockquote>
      </Row>
      <Row className="pt-7 lh-xs px-lg-0 px-7">
        <Blockquote>
          <section>
            <Row>
              <Col className="title-span fw-bolder">
                Flexible Spending Account (FSA)
              </Col>
            </Row>
            <Row>
              <Col>
                This tax advantaged account is great to use for out-of-pocket
                medical expenses but be sure to use the full account by the end
                of the year!
              </Col>
            </Row>
          </section>
        </Blockquote>
      </Row>
      <Row className="pt-7 lh-xs px-lg-0 px-7">
        <Blockquote>
          <section>
            <Row>
              <Col className="title-span fw-bolder">Tuition Reimbursement</Col>
            </Row>
            <Row>
              <Col>
                The company believes in our employees furthering their education
                and is happy to be able to assist monetarily!
              </Col>
            </Row>
          </section>
        </Blockquote>
      </Row>
    </div>
  );
};
export default OtherBenefitsTab;
